import { Button } from "@shapr3d/frontend-lib";
import classNames from "classnames";

import WarningIcon from "../../assets/images/warning-icon.svg";
import useTranslation from "../../hooks/useTranslation";
import Heading from "../Heading/Heading";

import style from "./ProgressiveProfilingError.module.css";

interface ProgressiveProfilingErrorProps {
  retryCallback: () => void;
}

const ProgressiveProfilingError: React.FC<ProgressiveProfilingErrorProps> = ({ retryCallback }) => {
  const { t, m } = useTranslation();

  return (
    <div className={style.progressiveProfilingError}>
      <div className={style.modalContainer}>
        <img src={WarningIcon} className={style.image}></img>
        <Heading type="h1">{t(m.ProgressiveProfiling.General.SomethingWentWrong)}</Heading>
        <div>
          <p className={style.message}>
            {t(m.ProgressiveProfiling.General.SubmittingYourAnswersWereFailed)}
          </p>
        </div>
        <div className={classNames(style.footer, style.footerSuccess)}>
          <Button className={style.retryButton} onClick={retryCallback}>
            {t(m.ProgressiveProfiling.General.Retry)}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ProgressiveProfilingError;
